export default __webpack_public_path__ + "static/media/stripe-legitimate.bcf3865e.png";